import type { Vertical } from '../config/consoleConfig.js';
import type { AdvisorData, GarnetApi, VerticalData } from './types.js';
import { AUTOMOTIVE_DATA } from './fixtures.automotive.js';
import { MEDICAL_DATA } from './fixtures.medical.js';
import { ADVISOR_DATA } from './advisor.js';

const BY_VERTICAL: Record<Vertical, VerticalData> = {
  medical: MEDICAL_DATA,
  automotive: AUTOMOTIVE_DATA,
};

/**
 * In-memory GarnetApi backed by fixtures so the console is fully interactive offline,
 * for BOTH launch verticals. Async to match the eventual network impl (HttpApi) — screens
 * cannot tell them apart (PRD §14.4: every view gets loading + error states).
 */
export class FixtureApi implements GarnetApi {
  getVerticalData(vertical: Vertical): Promise<VerticalData> {
    return Promise.resolve(BY_VERTICAL[vertical]);
  }
  getAdvisorData(): Promise<AdvisorData> {
    return Promise.resolve(ADVISOR_DATA);
  }
}
